import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { deleteIdData } from "../../../lib/studentlessons";
import { getStudentIdData } from "../../../lib/studentnotes";
import { useAuth } from "../../../usercontext";
import STopMenu from "../../../components/student/topmenu/topmenu";
import StudentTopMenu from "../studentinfo/studenttopmenu";
import StudentInfoBox from "../studentinfo/studentinfobox";
export default function ParentStudentNotes() {
  const [notes, setNotes] = useState([]);
  const [classforLesson, setClassForLesson] = useState(9);
  const { profile } = useAuth();

  let { slug } = useParams();
  const cls = profile.class;

  const handleDelete = async (id) => {
    const choice = window.confirm("Are You Sure?");
    if (choice) {
      await deleteIdData(id);
      //getDataWithTypeFromParamter();
      console.log("Delete", id);
      //router.refresh();
    }
  };

  async function getData() {
    const note = await getStudentIdData(slug);
    //console.log("lesson",lesson.filter(cat => cat.class == catg));
    setNotes(note);
    console.log("note", note);
  }

  useEffect(() => {
    getData(classforLesson);
  }, []);

  return (
    <>
      {/* <STopMenu slug={slug} activeMenu="PersonelQuestionsList" /> */}
      <StudentInfoBox slug={slug} />
      <StudentTopMenu slug={slug} activeMenu={"Task"} />

      <div className="col-12">
        <div className="settings-widget profile-details">
          <div className="settings-inner-blk p-0">
            <div className="profile-heading">
              <h3>Notes</h3>
              <div className="new-address">
                <div className="row">
                  <div className="col"></div>
                  <div className="col"> </div>
                  {/* <div className="col">
                    <Link
                      to="/student/student-notes-edit/Add/0"
                      className="btn btn-dark btn-dark-1"
                    >
                      Add New Note
                    </Link>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="comman-space pb-0">
              <div className="settings-invoice-blk table-responsive">
                {/* Invoice info */}
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Regarding</th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {notes.map(function (data) {
                      return (
                        <tr key={data.id}>
                          <td>
                            <Link to="#" className="invoice-no">
                              {data.id}
                            </Link>
                          </td>
                          <td>{data.title}</td>
                          <td>
                            <div className="profile-share d-flex align-items-center justify-content-end">
                              {/* <Link
                                to={`/student/student-notes-edit/Update/${data.id}`}
                                className="btn btn-success btn-sm"
                              >
                                Update
                              </Link> */}
                              {/*}
                                    <button className="btn btn-danger btn-sm" onClick={() => handleDelete(data.id)}>
                                      Delete
                                    </button>
                            */}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {/* Invoice info */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
